import { applyDocumentLanguage } from "./documentLang";

const STORAGE_KEY = "ecoAcceptLanguage";
const ALLOWED = new Set(["ar", "en"]);

/**
 * Dashboard Accept-Language for API responses (labels, messages).
 * Defaults to English until a UI language switcher sets otherwise.
 */
export function getAcceptLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (ALLOWED.has(stored)) return stored;
  } catch {
    // ignore storage errors
  }
  return "en";
}

export function setAcceptLanguage(lang) {
  if (!ALLOWED.has(lang)) return;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // ignore storage errors
  }
  applyDocumentLanguage(lang);
}
